import React, { forwardRef } from 'react';
import { generateCssProperties } from '@fiverr-private/theme';
import Layout from '../Layout';
import { BORDERS, DIMENSION } from './constants';
import { DividerProps } from './types';

const Divider = forwardRef<HTMLElement, DividerProps>(
  (
    {
      direction = { default: 'horizontal' },
      borderStyle = 'solid',
      borderWidth = 'sm',
      borderColor = 'border',
      width,
      height,
      dataTestId,
    }: DividerProps,
    ref
  ) => {
    const { borderTopWidth, borderLeftWidth } = generateCssProperties(direction, BORDERS, borderWidth, '0');
    const dimensionProperties = generateCssProperties(direction, DIMENSION, '100%', '0');

    return (
      <Layout
        ref={ref}
        borderTopWidth={borderTopWidth}
        borderLeftWidth={borderLeftWidth}
        width={width || dimensionProperties.width}
        height={height || dimensionProperties.height}
        data-testid={dataTestId}
        borderStyle={borderStyle}
        borderColor={borderColor}
      />
    );
  }
);

Divider.displayName = 'Divider';

export default Divider;
